import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ProfilePersonalDataModel } from '../models/profile-personal-data.model';
import { ProfileSettingsModel } from '../models/profile-settings.model';

import { ProfileModel } from '../models/profile.model';

const API_ENDPOINT = '/api/profile/';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {

  /**
   * Constructor
   *
   * @param http
   */
  public constructor(private http: HttpClient) {
  }

  /**
   * Get the profile information of the Authenticated User
   *
   * @return Observable<any>
   */
  public getProfileInfo(): Observable<ProfileModel> {
    return this.http.get<{ error: string, items: ProfileModel }>(API_ENDPOINT + 'get')
      .pipe(
        map((response: { error: string, items: ProfileModel }) => {
          return response.items;
        }),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }

  /**
   * Save the profile information for the Authenticated User
   *
   * @param settings
   *
   * @return Observable<ProfileSettingsModel>
   */
  public saveProfileSettings(settings: ProfileSettingsModel): Observable<ProfileSettingsModel> {

    return this.http.post(API_ENDPOINT + 'settings/save', settings)
      .pipe(
        map((response: { items: { settings: ProfileSettingsModel } }) => {
          return response.items.settings;
        }),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }

  /**
   * Save the profile information for the Authenticated User
   *
   * @param profileInfo
   */
  public saveProfileInfo(profileInfo): Observable<any> {

    return this.http.post(API_ENDPOINT + 'save', profileInfo)
      .pipe(
        map(
          (response: {
            message: {
              title: string,
              text: string,
            },
            items: {
              personalData: ProfilePersonalDataModel,
            },
          }) => {
            return response;
          }),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }

  /**
   * Save the profile information for the Authenticated User
   *
   * @param passwordData
   */
  public changePlayerPassword(passwordData): Observable<any> {
    return this.http.post(API_ENDPOINT + 'change-password', passwordData)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }
}
